export function formatBillingPriceWeb(amount, currency) {
    try {
        const options = {
            style: "currency",
            currency,
            ...(Number.isInteger(amount) ? { minimumFractionDigits: 0, maximumFractionDigits: 0 } : {}),
        };
        const parts = new Intl.NumberFormat(navigator.language, {
            ...options, currencyDisplay: "narrowSymbol",
        }).formatToParts(amount);
        const symbol = parts.find(part => part.type === "currency")?.value ?? currency;
        // Let Intl distinguish shared symbols ($, yen, pounds, won) and regional abbreviations.
        if (/[\p{L}$¥£₩]/u.test(symbol.normalize("NFKC"))) {
            return new Intl.NumberFormat(navigator.language, options).format(amount);
        }
        return parts.map(part => part.value).join("");
    } catch (error) {
        console.warn(`Formatting billing price failed: currency=${currency}`, error);
        return null;
    }
}
